import React, {useRef, useState} from 'react';
import {Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Row} from 'reactstrap';

import {
    error,
    FORM,
    saveErrorMsg
} from "../../../components/i18n/i18n";
import {
    ButtonCancel,
    ButtonEdit,
    ButtonNew,
    ButtonSubmit,
    GenericTableButton
} from "../../../components/buttons/buttonsActions";
import {showToastCustom} from "../../../components/toast/customToast";
import Switch from "react-bootstrap-switch";
import * as Yup from "yup";
import {useForm} from "react-hook-form";
import {showLoader} from "../../../components/loader/loader";
import {amenityTypeService} from "../../../jwt/_services/hotel/amenityTypeService";
import {TT_HISTORY} from "../../../components/i18n/toolTips";
import {LogHistoryModal} from "../../../components/logHistory/logHistoryModal";

export default function AmenityTypeForm(props) {

    const [editMode, setEditMode] = useState(!!props?.item?.id);
    const [disableInputs, setDisableInputs] = useState(false);
    const [saveSuccess, setSaveSuccess] = useState(false);
    const [savedData, setSavedData] = useState(editMode ? props.item : null);
    const [loading, setLoading] = useState(false);
    const [status, setStatus] = useState(editMode ? props.item?.status : false);
    const [showModal, setShowModal] = useState(true)
    const modalRef = useRef(null);

    const showHistory = () => {
        setShowModal(true);
        modalRef.current.showModal(savedData);
    }

    const validationSchema = Yup.object().shape({});

    const {register, handleSubmit, reset} = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            id: savedData?.id,
            code: savedData?.code,
        }
    });

    const onStatusChange = () => setStatus(!status);
    
    const onSubmit = (data, _) => {
        setLoading(true);

        let dataRequest = {
            id: data.id,
            status: status,
            code: data.code,
        };

        if (!editMode) {
            //Save
            return amenityTypeService.saveItem(dataRequest)
                .then(resultData => {
                    if(resultData?.id)
                        setResult(resultData);
                    else 
                        showToastCustom(error, saveErrorMsg)
                    
                    setLoading(false);
                })
                .catch(errorMessage => {
                    setLoading(false);
                    showToastCustom(error, errorMessage);
                });
        } else {
            //Update
            let id = savedData.id;

            dataRequest = { ...dataRequest, id }

            return amenityTypeService.updateItem(id, dataRequest)
                .then(resultData => {
                    setResult(resultData);
                    setLoading(false);
                })
                .catch(errorMessage => {
                    setLoading(false);
                    showToastCustom(error, errorMessage);
                });
        }
    };


    const setResult = (resultData) => {
        setLoading(false);
        setSavedData(resultData);
        setDisableInputs(true);
        setSaveSuccess(true);
        setEditMode(true);
    }

    const resetForm = () => {
        setSavedData(null);
        setStatus(false);
        setEditMode(false);
        setDisableInputs(false);
        setSaveSuccess(false);
        reset();
    }

    const beginEdit = () => {
        setEditMode(true);
        setSaveSuccess(false)
        setDisableInputs(false);
    }

    

    const setForm = () => props.setForm(null, null, "LIST");
    

    return (
        <Card>
            {loading ? showLoader() : null}
            <CardTitle className="bg-light border-bottom p-3 mb-0">
                <i className="far fa-edit mr-2"/>{FORM}
                {
                    editMode && <div className="float-right">
                        <GenericTableButton
                            toolTip={TT_HISTORY}
                            icon={'fa-clock'}
                            permission={'search'}
                            onClick={showHistory}
                        />
                    </div>
                }
            </CardTitle>
            <CardBody>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <Row>
                        {
                            editMode && <Col md="4">
                                <FormGroup>
                                    <Label>ID</Label>
                                    <Input type="id" name="id" id="id"
                                        disabled
                                        value={editMode ? savedData?.id : ''}
                                    />
                                </FormGroup>
                            </Col>

                        }
                        <Col md="3">
                            <FormGroup>
                                <Label>Codigo</Label>
                                <Input type="text" name="code"
                                       placeholder="Codigo"
                                       innerRef={register}
                                       disabled={disableInputs}/>
                            </FormGroup>
                        </Col>
                        <Col md="2">
                            <FormGroup>
                                <Label>Activo</Label>
                                <br/>
                                <Switch animate={true} offText={"No"} onText={"Si"}
                                        value={status}
                                        disabled={disableInputs}
                                        onChange={onStatusChange}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    
                    <CardBody className="border-top">
                        {
                            saveSuccess ?
                                <div className="float-right">
                                    <ButtonNew onClick={() => resetForm()}/>
                                    <ButtonEdit onClick={() => beginEdit() }/>
                                    <ButtonCancel onClick={setForm}/>
                                </div>
                                : <div className="float-right">
                                    <ButtonSubmit/>
                                    <ButtonCancel onClick={setForm}/>
                                </div>
                        }
                    </CardBody>
                </Form>
            </CardBody>
            {
                showModal && <LogHistoryModal
                    ref={ modalRef }
                    item={ savedData }
                />
            }
        </Card>
    )
}